import * as React from 'react';
import { Team } from '../../../models';
import { FilterStore } from '../../../stores';
import { observer, inject } from 'mobx-react';
import { PVASelect, PVASelectOption } from './PVASelect';
import './PVASelect.css';

interface PVATeamSelectProps {
    options: Team[];
    selected: number | undefined;
    onChange: Function;
    FilterStore?: FilterStore;
    defaultOptions?: any[];
    disabled?: boolean;
}

@inject('FilterStore') @observer
export class PVATeamSelect extends React.Component<PVATeamSelectProps, {}> {
    private mapTeamsToOptions(teams: Team[]): PVASelectOption[] {
        return (teams || []).map((team: Team) => ({
            id: team.id,
            label: team.name
        }));
    }

    private sortOptions = (a: PVASelectOption, b: PVASelectOption) => {
        if (a.label > b.label) return 1;
        if (a.label < b.label) return -1;
        return 0;
    }

    render() {
        const { options, selected, onChange, defaultOptions, disabled } = this.props;
        const mapped = this.mapTeamsToOptions(options);
        const mappedDefaults = defaultOptions ? defaultOptions.map((o) => ({ id: o.id, label: o.value || o.label })) : undefined;

        return (
            <PVASelect
                options={mapped}
                selected={selected}
                onChange={onChange}
                defaultOptions={mappedDefaults}
                noSelectTitle={'- Select Team -'}
                sortOptions={this.sortOptions}
                disabled={disabled}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/reports/blocks/PVATeamSelect.tsx